import { useEffect, useState } from "react";
import { Check, X, ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { Card, Btn, CategoryIcon } from "@/components/portal/ui";

export function ApprovalList() {
  const { t, L } = useI18n();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    const { data } = await api.get("/admin/providers", { params: { status: "pending" } });
    setItems(data);
    setLoading(false);
  };

  useEffect(() => {
    load();
  }, []);

  const approve = async (id) => {
    await api.post(`/admin/providers/${id}/approve`);
    load();
  };
  const reject = async (id) => {
    await api.post(`/admin/providers/${id}/reject`, { reason: "" });
    load();
  };

  if (loading) return <div className="text-sm py-10" style={{ color: "var(--text-muted)" }}>{t("common.loading")}</div>;

  if (!items.length)
    return (
      <Card className="p-12 flex flex-col items-center gap-3 text-center" data-testid="approvals-empty">
        <ShieldCheck className="h-8 w-8" style={{ color: "var(--accent)" }} />
        <span style={{ color: "var(--text-muted)" }}>{t("approve.empty")}</span>
      </Card>
    );

  return (
    <div className="space-y-3" data-testid="approval-list">
      {items.map((p) => (
        <Card key={p.id} className="p-4 flex items-center gap-4 kw-fade-up" data-testid={`approval-item-${p.id}`}>
          <div className="h-14 w-14 shrink-0 overflow-hidden flex items-center justify-center" style={{ background: "var(--surface-alt)", borderRadius: "var(--radius)" }}>
            {p.cover_image ? <img src={p.cover_image} alt="" className="h-full w-full object-cover" /> : <CategoryIcon name={p.categories?.[0]?.icon} className="h-6 w-6" style={{ color: "var(--text-muted)" }} />}
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-heading text-lg font-semibold" style={{ color: "var(--text)" }}>{p.business_name}</div>
            <div className="text-sm truncate" style={{ color: "var(--text-muted)" }}>
              {p.categories?.map((c) => L(c.name)).join(", ")} · {L(p.location_name)}
            </div>
          </div>
          <div className="flex gap-2">
            <Btn variant="accent" onClick={() => approve(p.id)} data-testid={`approval-action-approve-${p.id}`}>
              <Check className="h-4 w-4" /> {t("approve.approve")}
            </Btn>
            <Btn variant="danger" onClick={() => reject(p.id)} data-testid={`approval-action-reject-${p.id}`}>
              <X className="h-4 w-4" /> {t("approve.reject")}
            </Btn>
          </div>
        </Card>
      ))}
    </div>
  );
}
